.availabilityTooltip {
  max-height: 200px;
  overflow: auto;
}
